import React, { FC } from 'react';
import cn from 'classnames';

import { TProps } from './models';

export const Img: FC<TProps> = ({
    alt,
    className,
    radiusKind = 'default',
    responsive = false,
    srcRetina,
    styles,
    ...rest
}) => (
    <img
        alt={alt}
        className={cn(
            // @ts-ignore
            styles[`${radiusKind}KindRadius`],
            {
                [styles.responsive]: responsive,
            },
            className
        )}
        srcSet={srcRetina ? `${srcRetina} 2x` : undefined}
        {...rest}
    />
);
